/**
 * Chart Slider
 * Initializes Swiper.js for chart slides on desktop, disabled on mobile
 */

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export const initChartSlider = () => {
  const sliders = document.querySelectorAll('.chart-slider-wrapper');

  if (sliders.length === 0) {
    return;
  }

  const desktopMediaQuery = window.matchMedia('(min-width: 981px)');

  for (const sliderWrapper of sliders) {
    let swiperInstance = null;

    const positionArrows = () => {
      // Find the active slide's chart-content
      const activeSlide = sliderWrapper.querySelector('.swiper-slide-active');
      const chartContent = activeSlide
        ? activeSlide.querySelector('.chart-content')
        : null;
      const prevEl = sliderWrapper.querySelector('.swiper-button-prev');
      const nextEl = sliderWrapper.querySelector('.swiper-button-next');

      if (
        chartContent instanceof HTMLElement &&
        prevEl instanceof HTMLElement &&
        nextEl instanceof HTMLElement
      ) {
        const rect = chartContent.getBoundingClientRect();
        const containerRect = sliderWrapper.getBoundingClientRect();
        const centerY = rect.top - containerRect.top + rect.height / 2;

        prevEl.style.top = `${centerY}px`;
        nextEl.style.top = `${centerY}px`;
      }
    };

    const handleMediaChange = (e) => {
      const swiperEl = sliderWrapper.querySelector('.swiper');
      if (!(swiperEl instanceof HTMLElement)) {
        return;
      }

      if (e.matches) {
        // Desktop: Initialize Swiper
        if (!swiperInstance) {
          const nextEl = sliderWrapper.querySelector('.swiper-button-next');
          const prevEl = sliderWrapper.querySelector('.swiper-button-prev');

          if (!(prevEl instanceof HTMLElement)) {
            return;
          }
          if (!(nextEl instanceof HTMLElement)) {
            return;
          }

          swiperInstance = new Swiper(swiperEl, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 30,
            speed: 300,
            navigation: {
              nextEl: nextEl,
              prevEl: prevEl,
            },
            on: {
              init: () => {
                setTimeout(() => {
                  positionArrows();
                }, 100);
              },
              slideChange: () => {
                setTimeout(() => {
                  positionArrows();
                }, 100);
              },
              transitionEnd: () => {
                positionArrows();
              },
            },
          });
        }
      } else {
        // Mobile: Destroy Swiper
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      }
    };

    // Initialize on load
    handleMediaChange(desktopMediaQuery);

    // Listen for viewport changes
    desktopMediaQuery.addEventListener('change', handleMediaChange);

    // Recalculate when slider wrapper resizes
    const resizeObserver = new ResizeObserver(() => {
      if (swiperInstance) {
        positionArrows();
      }
    });
    resizeObserver.observe(sliderWrapper);
  }
};
